import { type PropsWithChildren, useEffect, useRef } from "react";
import ReactDOM from "react-dom";

export interface PortalProps {
  targetId: string;
}

export default function Portal(props: PropsWithChildren<PortalProps>) {
  const { children, targetId } = props;
  const portalRootRef = useRef(document.getElementById(targetId));
  const portalElementRef = useRef(document.createElement("div"));

  useEffect(() => {
    const portalRoot = portalRootRef.current;
    const portalElement = portalElementRef.current;

    if (portalRoot && portalElement) {
      portalRoot.appendChild(portalElement);
    }

    return () => {
      if (portalRoot && portalElement && portalRoot.contains(portalElement)) {
        portalRoot.removeChild(portalElement);
      }
    };
  }, [targetId]);

  return portalElementRef.current
    ? ReactDOM.createPortal(children, portalElementRef.current)
    : null;
}
